import { render, staticRenderFns } from "./topups.vue?vue&type=template&id=a4115726"
import script from "./topups.vue?vue&type=script&lang=js"
export * from "./topups.vue?vue&type=script&lang=js"
import style0 from "./topups.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports